import { Button } from "../../component/button"

export const ErrorScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-900 p-6">
      <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
        <h1 className="text-3xl font-bold mb-2">Something went wrong</h1>
        <p className="text-gray-600 mb-4">An unexpected error occurred. Please try again later.</p>
        <div className="flex gap-4 justify-center">
          <Button onClick={() => window.location.reload()}>Retry</Button>
        </div>
      </div>
    </div>
  )
}
